import { SchemeOptional } from "@/type/commonTypes";
import { Scheme } from "@/type/schemeType";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface InvestmentModalState {
  isOpen: boolean;
  schemeData: SchemeOptional | Scheme | null;
}

const initialState: InvestmentModalState = {
  isOpen: false,
  schemeData: null,
};

const investmentModalSlice = createSlice({
  name: "investmentModal",
  initialState,
  reducers: {
    openInvestmentModal: (state, action: PayloadAction<SchemeOptional>) => {
      state.isOpen = true;
      state.schemeData = action.payload;
    },
    closeInvestmentModal: (state) => {
      state.isOpen = false;
      state.schemeData = null;
    },
  },
});

export const { openInvestmentModal, closeInvestmentModal } = investmentModalSlice.actions;
export default investmentModalSlice.reducer;
